import { Conversation } from "@accurx/concierge/types";

export const getNumberOfAssignments = (conversation: Conversation) => {
    return conversation.items.filter(
        (item) => item.contentType === "StateChange" && !!item.assignedTo,
    ).length;
};
